const EMPLOYEE_ID_PATTERN = /^[a-zA-Z0-9.*$#&-]*$/;

const AGENCY_ID_PATTERN = /^[a-zA-Z0-9.*$#&-]*$/;

const PASSWORD_PATTERN = /[^A-Za-z0-9]+/;

export { EMPLOYEE_ID_PATTERN, AGENCY_ID_PATTERN, PASSWORD_PATTERN };
